export default [
  {
    path: ':path(deliveries.*)?',
    name: 'inventory.deliveries',
    beforeEnter: (to, from, next) => {
      // :path(deliveries.*)? path doesn't add deliveries to url so it needs to be added manually
      // this change in path is needed to handle url in more elastic way for Inventory micro-frontend
      if (!to.path.includes('inventory/deliveries')) {
        return next({
          path: to.path + (to.path.endsWith('/') ? '' : '/') + 'deliveries',
          query: to.query,
          hash: to.hash,
        })
      }

      next()
    },
    component: () => import('@/views/business/inventory/deliveries/iframe-service.vue'),
  },
]
